import React from 'react'
import styled from 'styled-components'
import CampaignButton from 'components/ActiveButton'
import Card from 'react-bootstrap/Card'
import image from 'assets/images/widgets/jazeel-cloud.png'
const Wrapper = styled(Card)`
  box-shadow: 0 2px 26px 0 rgba(0, 0, 0, 0.08);
  border-radius: 10px;

  padding: 3.438em 1.813em 1.5em;
  margin-top: 1.875em;
  background: white;
  @media screen and (max-width: 350px) {
    padding-left: 1em;
    padding-right: 1em;
  }
  &:after {
    content: '';
    position: absolute;
    background: url(${image}) no-repeat right top;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-size: auto;
    opacity: 0.4;
    @media screen and (max-width: 768px) {
      left: 5em;
    }
  }
`
const Title = styled.h1`
  color: #212529;
  font-size: 1.5em;
  font-weight: bold;
  line-height: 1.813em;
`
const Info = styled.p`
  color: #212529;
  font-size: 0.875em;
  line-height: 1.125em;
  text-align: justify;
  padding-bottom: 2.563em;
`
export default function Influencing() {
  return (
    <Wrapper>
      <Card.Body className="p-0">
        <Title>Start Influencing</Title>
        <Info>
          Connect your social media accounts and attract top brands to
          collaborate with you and earn income and great rewards
        </Info>
        <CampaignButton
          text="Connect"
          background="linear-gradient(45deg, #11BED3 0%, #9CDF61 100%)"
          borderRadius="10px"
          textColor="#ffffff"
          textSize="0.8em"
          width="17em"
          height="3em"
        />
      </Card.Body>
    </Wrapper>
  )
}
